import Swiper, {Navigation, Pagination} from 'swiper';

export default function swiper() {

    new Swiper('.block-reviews .swiper', {
        autoplay: {
            delay: 5000,
        },
        spaceBetween: 40,
        slidesPerView: 1,
        loop: true,
        navigation: {
            nextEl: '.block-reviews .swiper-button-next',
            prevEl: '.block-reviews .swiper-button-prev',
            clickable: true
        },
        breakpoints: {
            1000: {
                slidesPerView: 3,
                spaceBetween: 40,
            },
        },
        modules: [Navigation]
    })



    new Swiper('.block-doctors-shortcode .swiper', {
        autoplay: {
            delay: 5000,
        },
        spaceBetween: 20,
        slidesPerView: 1,
        loop: false,
        pagination: {
            el: '.block-doctors-shortcode .swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.block-doctors-shortcode .swiper-button-next',
            prevEl: '.block-doctors-shortcode .swiper-button-prev',
            clickable: true
        },
        breakpoints: {
            1160: {
                slidesPerView: 2,
            },
        },
        modules: [Navigation, Pagination]
    })

    new Swiper('.block-wards-shortcode .swiper', {
        autoplay: {
            delay: 5000,
        },
        spaceBetween: 20,
        slidesPerView: 1,
        autoHeight: true,
        loop: false,
        pagination: {
            el: '.block-wards-shortcode .swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.block-wards-shortcode .swiper-button-next',
            prevEl: '.block-wards-shortcode .swiper-button-prev',
            clickable: true
        },
        breakpoints: {
            1140: {
                slidesPerView: 2,
            },
        },
        modules: [Navigation, Pagination]
    })

    new Swiper('.b-gallery .swiper', {
        autoplay: {
            delay: 5000,
        },
        spaceBetween: 40,
        slidesPerView: 1,
        loop: false,
        pagination: {
            el: '.b-gallery .swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.b-gallery .swiper-button-next',
            prevEl: '.b-gallery .swiper-button-prev',
            clickable: true
        },
        breakpoints: {
            1160: {
                slidesPerView: 3,
            },
        },
        modules: [Navigation, Pagination]
    })

    new Swiper('.block-licenses .swiper', {
        autoplay: {
            delay: 5000,
        },
        spaceBetween: 40,
        slidesPerView: 1,
        loop: false,
        pagination: {
            el: '.block-licenses .swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.block-licenses .swiper-button-next',
            prevEl: '.block-licenses .swiper-button-prev',
            clickable: true
        },
        breakpoints: {
            1160: {
                slidesPerView: 3,
            },
        },
        modules: [Navigation, Pagination]
    })

    new Swiper('.block-options .swiper', {
        autoplay: {
            delay: 5000,
        },
        spaceBetween: 0,
        slidesPerView: 1,
        loop: false,
        pagination: {
            el: '.block-options .swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.block-options .swiper-button-next',
            prevEl: '.block-options .swiper-button-prev',
            clickable: true
        },
        modules: [Navigation, Pagination]
    })

    new Swiper('.b-related-posts .swiper', {
        autoplay: {
            delay: 5000,
        },
        spaceBetween: 40,
        slidesPerView: 1,
        loop: false,
        navigation: {
            nextEl: '.b-related-posts .swiper-button-next',
            prevEl: '.b-related-posts .swiper-button-prev',
            clickable: true
        },
        breakpoints: {
            1160: {
                slidesPerView: 3,
            },
        },
        modules: [Navigation]
    })

}
